import React from 'react';

import PropTypes from 'prop-types';

import Tooltip from 'components/application/Tooltip';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function Icon({
  domainIcon,
  isChecked,
  isDisabled,
  onCheckboxChange,
}) {
  const {
    attributes: { imageAssetPath, name },
    id,
  } = domainIcon;

  return (
    <label className='method_icon'>
      <img
        alt={name}
        className='tw-border-grey-100'
        height={75}
        src={imageAssetPath}
        width={75}
      />
      <input
        checked={isChecked}
        className='icon_checkbox'
        disabled={isDisabled}
        id={id}
        onChange={onCheckboxChange}
        type='checkbox'
      />
      <Tooltip placement='bottom' tooltip={name} trigger='hover'>
        <span className='tw-line-clamp-3 tw-font-normal'>{name}</span>
      </Tooltip>
    </label>
  );
}

Icon.propTypes = {
  domainIcon: resourceShape('icon').isRequired,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onCheckboxChange: PropTypes.func.isRequired,
};
